import script from "./UserDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDescription.vue?vue&type=script&lang=ts&setup=true"

import "./UserDescription.vue?vue&type=style&index=0&id=c462e58a&lang=css"

const __exports__ = script;

export default __exports__